import Pusher from "pusher-js";
var pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
  cluster: process.env.REACT_APP_PUSHER_CLUSTER
});
var channel = pusher.subscribe("uhuru");

export default channel;
